<template>
  <div class="passengerInfoTable row">
    <!-- 第一行 -->
    <el-row :gutter="10" class="custom-row">
      <!-- 進線電話 -->
      <el-col :span="12" class="custom-col">
        <div class="input-row-flex">
          <span class="passengerInfoTable__title">進線電話:</span>
          <InputCustomerPhone
            :customerPhone="customerPhone"
            @updateCustomerPhone="updateCustomerPhone"
            @searchCustomerInfo="$emit('searchCustomerInfo')"
            class="input-flex"
          />
          <BaseButton
            class="passengerInfoTable__button passengerInfoTable__button--search"
            :text="'查詢'"
            :backgroundColor="'#4B5F71'"
            :textColor="'#E9EDEF'"
            @click="onSearch"
          />
          <BaseButton
            class="passengerInfoTable__button passengerInfoTable__button--clear"
            :text="'欄位全部清空'"
            :backgroundColor="'#F0AD4F'"
            :textColor="'#FFFFFF'"
            @click="onClearAll"
          />
        </div>
      </el-col>
      <!-- 選單(性別/車輛/乘客/派遣按鈕) -->
      <el-col :span="12" class="custom-col">
        <el-row class="inline-row">
          <!-- 性別選擇 -->
          <el-col :span="5" class="selector-col">
            <div class="inline-flex-center">
              <GenderSelector
                :selectValue="gender"
                @selectChangeHandler="setGender"
              />
            </div>
          </el-col>
          <!-- 車輛數量選擇 -->
          <el-col :span="6" class="selector-col">
            <VehicleAmountSelector
              :selectValue="vehicles"
              @selectChangeHandler="setNumberOfVehicle"
            ></VehicleAmountSelector>
          </el-col>
          <!-- 乘客數量選擇 -->
          <el-col :span="6" class="selector-col">
            <PassengerAmountSelector
              :selectValue="people"
              @selectChangeHandler="setNumberOfPassenger"
            ></PassengerAmountSelector>
          </el-col>
          <!-- 派遣按鈕 -->
          <el-col :span="7">
            <div class="dispatch-flex">
              <BaseButton
                class="passengerInfoTable__button passengerInfoTable__button--clear"
                v-show="!isWarning"
                @click="handleSubmitHailOrder"
                :text="'自動派遣'"
                :backgroundColor="'#449d44'"
                :textColor="'#FFFFFF'"
                :disabled="isDisable"
              ></BaseButton>
              <span
                class="speedNormal"
                :class="{ speedError: isDownloadSpeedError }"
              >
                <i
                  v-if="isDownloadSpeedError"
                  class="el-icon-error"
                  style="color: red"
                ></i>
                {{ downloadSpeedStatus }}
              </span>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 第二行 -->
    <el-row :gutter="10" class="custom-row">
      <!-- 連絡電話/公里數 -->
      <el-col :span="12" class="custom-col">
        <div class="input-row-flex">
          <span class="passengerInfoTable__title">聯絡電話:</span>
          <input
            v-model="contactPhone"
            @change="onContactPhone"
            class="passengerInfoTable__inputField"
            type="text"
            required="required"
            style="width: 180px; margin-right: 12px"
          />
          <el-select
            v-model="selectedPhone"
            @change="onSelectedPhone"
            placeholder="請選擇"
            class="select-phone"
            style="width: 150px; margin-right: 12px"
          >
            <el-option
              v-for="phone in vx_phoneList.recentPhones"
              :key="phone"
              :label="phone"
              :value="phone"
            ></el-option>
          </el-select>
          <BaseButton
            class="passengerInfoTable__button passengerInfoTable__button--clear"
            v-show="!isWarning"
            :text="'同來電'"
            :backgroundColor="'#337ab7'"
            :textColor="'#FFFFFF'"
            @click="onSameCustomerPhone"
            style="margin-left: 0px"
          ></BaseButton>
        </div>
        <div class="input-row-flex distance-row">
          <DistanceSelector
            :selectValue="distance"
            @selectChangeHandler="setDistance"
            class="distance-selector"
          ></DistanceSelector>
        </div>
      </el-col>
      <!-- 客服備註 -->
      <el-col :span="12" class="custom-col">
        <el-row :gutter="10">
          <el-col :span="24" class="baseline-col">
            <h4 class="passengerInfoTable__title">客服備註:</h4>
            <el-input
              class="inputServiceCommand"
              type="textarea"
              :rows="2"
              placeholder="客服備註,客服備註"
              :value="serviceCommand"
              @input="updateServiceCommand"
            />
            <div
              class="passengerInfoTable__checkboxContainer"
              v-show="isWarning"
            >
              <label>
                <input
                  class="passengerInfoTable__checkbox"
                  type="checkbox"
                  :checked="isWarning"
                  @change="updateIsBlacklist"
                />
                <span>黑名單(無記錄功能)</span>
              </label>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 第三行 -->
    <el-row :gutter="10" class="custom-row">
      <!-- 特約廠商名稱 -->
      <el-col :span="12" class="custom-col">
        <h4 class="passengerInfoTable__title">特約廠商名稱: {{ storeName }}</h4>
      </el-col>
      <!-- 排班策略 -->
      <el-col :span="12" class="custom-col">
        <el-row class="inline-row">
          <el-col :span="24">
            <AssignStrategySelector
              :selectValue="assignStrategy"
              @selectChangeHandler="setAssignStrateg"
            ></AssignStrategySelector>
            <div class="passengerInfoTable__checkboxContainer">
              <label class="passengerInfoTable__label">
                <input
                  class="passengerInfoTable__checkbox"
                  type="checkbox"
                  :checked="isSupport"
                  @change="updateSupportDriver"
                />
                <span>支援司機</span>
              </label>
              <label class="passengerInfoTable__label">
                <input
                  class="passengerInfoTable__checkbox"
                  type="checkbox"
                  :checked="isNearlyDriver"
                  @change="updateNearlyDriver"
                />
                <span>最近司機</span>
              </label>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import AssignStrategySelector from '@/components/common/select/AssignStrategySelector'
import DistanceSelector from '@/components/common/select/DistanceSelector'
import GenderSelector from '@/components/common/select/GenderSelector'
import InputCustomerPhone from '@/components/common/input/InputCustomerPhone'
import PassengerAmountSelector from '@/components/common/select/PassengerAmountSelector'
import VehicleAmountSelector from '@/components/common/select/VehicleAmountSelector'
import BaseButton from '@/components/common/button/BaseButton'

export default {
  props: {
    storeName: {
      type: String,
    },
    customerPhone: {
      required: true,
    },
    serviceCommand: {
      required: true,
    },
    assignStrategy: {
      type: Number,
      required: true,
    },
    distance: {
      type: Number,
      required: true,
    },
    gender: {
      type: Number,
      required: true,
    },
    vehicles: {
      type: Number,
      required: true,
    },
    people: {
      type: Number,
      required: true,
    },
    isWarning: {
      type: Boolean,
      required: true,
    },
    isSupport: {
      type: Boolean,
      required: false,
    },
    isNearlyDriver: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isDisable: false,
      isDownloadSpeedError: false,
      intervalId: null,
      contactPhone: '',
      selectedPhone: '',
    }
  },
  methods: {
    ...mapMutations('hail', {
      vx_setPhoneList: 'setPhoneList',
    }),
    handleSubmitHailOrder() {
      this.isDisable = true
      this.$emit('hailingGeneralCar')
      // 一秒後在解除button disable防止使用者連續點擊
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
    },
    updateCustomerPhone(value) {
      this.contactPhone = value
      this.onContactPhone()
      this.$emit('updateHailTaxiInfo', { item: 'customer_phone', value })
    },
    updateServiceCommand(value) {
      this.$emit('updateHailTaxiInfo', { item: 'serviceCommand', value })
    },
    updateIsBlacklist($event) {
      const { checked } = $event.target
      this.$emit('updateIsBlacklist', checked)
    },
    setGender(value) {
      this.$emit('selectChangeHandler', { item: 'gender', value })
    },
    setNumberOfVehicle(value) {
      this.$emit('selectChangeHandler', { item: 'vehicles', value })
    },
    setNumberOfPassenger(value) {
      this.$emit('selectChangeHandler', { item: 'people', value })
    },
    setDistance(value) {
      this.$emit('selectChangeHandler', { item: 'distance', value })
    },
    setAssignStrateg(value) {
      this.$emit('selectChangeHandler', { item: 'assignStrategy', value })
    },
    updateSupportDriver($event) {
      const { checked } = $event.target
      this.$emit('updateSupportDriver', checked)
    },
    updateNearlyDriver($event) {
      const { checked } = $event.target
      this.$emit('updateNearlyDriver', checked)
    },
    /* 派車頁面透過url params ANI接收進線電話(i.e. BASE_URL/serviceMain/phoneHail?ANI=0909998064)
     * onSearchWithANI function用意為，當進線電話帶入時parent component(即PhoneHail)會在mounted的lifecycle hooks執行此function
     * 使得進線電話與聯絡電話同步，並找尋乘客曾經上車的地址
     */
    onSearchWithANI(ani) {
      this.contactPhone = ani
      this.$emit('searchCustomerInfo')
    },
    onSearch() {
      this.contactPhone = this.customerPhone
      this.selectedPhone = ''
      this.$emit('searchCustomerInfo')
    },
    onSelectedPhone() {
      this.contactPhone = this.selectedPhone
      this.onContactPhone()
    },
    onContactPhone() {
      this.$emit('updateContactPhone', this.contactPhone)
    },
    onSameCustomerPhone() {
      this.contactPhone = this.customerPhone
      this.$emit('sameCustomerPhone')
    },
    onClearAll() {
      this.contactPhone = ''
      this.selectedPhone = ''
      this.vx_setPhoneList({
        primaryPhone: '',
        recentPhones: [],
      })
      this.$emit('clearAllData')
    },
  },
  computed: {
    ...mapState('hail', {
      vx_phoneList: 'phoneList',
    }),
    downloadSpeedStatus() {
      if (this.isDownloadSpeedError) {
        return '網路異常'
      } else {
        return '網路正常'
      }
    },
  },
  watch: {
    contactPhone: function () {
      this.onContactPhone()
    },
  },
  mounted() {
    this.intervalId = setInterval(() => {
      if (navigator.connection.downlink < 5 || !navigator.onLine) {
        console.error('網路異常')
        this.isDownloadSpeedError = true
      } else {
        this.isDownloadSpeedError = false
      }
    }, 5 * 1000)
  },
  components: {
    AssignStrategySelector,
    DistanceSelector,
    GenderSelector,
    InputCustomerPhone,
    PassengerAmountSelector,
    VehicleAmountSelector,
    BaseButton,
  },
}
</script>

<style lang="scss" scoped>
.passengerInfoTable {
  border: 2px solid #989898;
  background-color: #ffe6e6;
  padding: 10px 10px;

  &__title {
    margin: 0;
    font-size: 18px;
    color: black;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    margin-right: 10px;
  }

  &__inputField {
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
  }

  &__checkboxContainer {
    display: inline-block;
    vertical-align: middle;
  }

  &__label {
    margin: 0;
    height: 36px;
    line-height: 36px;
    display: inline-block;

    &:last-child {
      margin-left: 15px;
    }

    & span {
      margin-left: 5px;
      font-size: 16px;
    }
  }

  &__checkbox {
    zoom: 150%;
    margin: 0;
    vertical-align: text-top;
  }

  &__button {
    height: 36px;
    margin: 0 0 0 10px;
    outline: none;

    &--search {
      width: 60px;
    }
    &--clear {
      width: 135px;
    }
  }
}

/* flex row 通用設定 */
.inline-row,
.inline-row_commandInput,
.dispatch-flex,
.input-row-flex {
  display: flex;
  align-items: center;
}

.inline-row_commandInput {
  align-items: baseline;
  width: 100%;
}

.inline-flex-center {
  display: flex;
  align-items: center;
}

.input-row-flex {
  gap: 12px;
}

.input-row-flex .passengerInfoTable__title,
.distance-row >>> .baseSelector__title {
  min-width: 90px;
  text-align: left;
  display: inline-block;
}

.input-row-flex .input-flex {
  flex: 1 1 200px;
  width: 180px;
  max-width: 180px;
}

.select-phone {
  width: 180px;
}

.input-row-flex .passengerInfoTable__button {
  margin-left: 12px;
  min-width: 80px;
}

.inputServiceCommand {
  width: 80%;
  resize: none;

  >>> .el-textarea__inner {
    width: 440px;
    color: red;
    font-weight: 700;
    font-size: 16px;
  }
}

.checkboxBlacklist {
  zoom: 150%;
}

.input-hailing-style {
  background: #ffe6e6;
}

.hailing {
  color: #101010;
}

.speedNormal {
  color: #449d44;
  min-width: 80px;
  margin-left: 12px;
  display: inline-block;
}

.speedError {
  color: red;
}

/* selector 樣式合併 */
.selector-col {
  padding: 0;
}

.distance-row {
  width: 100%;
}

.distance-selector,
.passenger-selector {
  width: 100%;
  display: block;
}

/* el-select 樣式覆蓋 */
>>> .el-select {
  width: 100%;
}

/* baseSelector__title 樣式覆蓋 */
>>> .baseSelector__title {
  display: inline-block;
  width: auto;
  margin-right: 8px;
  vertical-align: middle;
  padding: 0 10px 0 0;
}

/* 距離選擇器標題額外間距 */
.distance-row >>> .baseSelector__title {
  margin-right: 22px;
}

/* 派遣按鈕區塊 */
.dispatch-flex .passengerInfoTable__button--clear {
  flex: 0 0 135px;
}

.dispatch-btn {
  margin-right: auto;
}
.custom-row {
  margin-bottom: 0px;
}

/* 客服備註 flex baseline 對齊 */
.baseline-col {
  display: flex;
  align-items: baseline;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailTaxi/PassengerInfoTable.vue